import "./VideoForm.scss";
import thumbnail from "../../assets/Images/Upload-video-preview.jpg";
import publishIcon from "../../assets/Icons/publish.svg";
import { Link, Redirect } from "react-router-dom";
import React from "react";
import axios from "axios";
import Swal from "sweetalert2";

const apiURL = process.env.API_URL;
class VideoForm extends React.Component {
  state = {
    isRedirecting: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const videoTitle = event.target.uploadTitle.value;
    const videoDescription = event.target.uploadDescrip.value;

    //validation checking if form fields are empty
    if (!videoTitle.trim() || !videoDescription.trim()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill in all the form fields",
      });
    } else {
      //post comments to api using axios
      axios
        .post(apiURL, {
          title: videoTitle,
          description: videoDescription,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
      //redirected to upload success page
      this.setState({
        isRedirecting: true,
      });
      event.target.reset();
    }
  };
  render() {
    if (this.state.isRedirecting) {
      return <Redirect to="/upload-success" />;
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="upload__container">
          <div className="upload__thumb-container">
            <p className="upload__thumb-text">Video Thumbnail</p>
            <img
              className="upload__thumb-img"
              src={thumbnail}
              alt="video still"
            ></img>
          </div>
          <div className="upload__form-container">
            <div className="upload__form-container--title">
              <label className="upload__label" htmlFor="uploadTitle">
                Title your video
              </label>
              <input
                className="upload__title-input"
                type="text"
                name="uploadTitle"
                id="uploadTitle"
                placeholder="Add a title to your video"
              ></input>
            </div>
            <div className="upload__form-container--description">
              <label className="upload__label" htmlFor="uploadDescrip">
                Add a video description
              </label>
              <input
                className="upload__description-input"
                type="text"
                name="uploadDescrip"
                id="uploadDescrip"
                placeholder="Add a description to your video"
              ></input>
            </div>
          </div>
        </div>
        <div className="upload__button-container">
          <Link to="/videos" className="upload__link">
            <p className="upload__cancel cancelMobile">CANCEL</p>
          </Link>
          <div className="upload__button-container--icon">
            <img
              className="upload__icon"
              src={publishIcon}
              alt="upload icon"
            ></img>
            <button id="publishBtn" className="upload__button" type="submit">
              PUBLISH
            </button>
          </div>
          <Link to="/videos" className="upload__link">
            <p className="upload__cancel cancelTablet">CANCEL</p>
          </Link>
        </div>
      </form>
    );
  }
}

export default VideoForm;
